import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Controller } from "@hotwired/stimulus";
import { isEmpty } from "lodash";

const PropertySetEditWrapper = lazy(
  () => import("../../components/administration/PropertySetEditWrapper"),
);

// Connects to data-controller="shared--property-set-edit"
export default class extends Controller {
  static values = { name: String, groupSlug: String };
  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <Suspense fallback={null}>
        <PropertySetEditWrapper
          propertySetName={this.nameValue}
          groupSlug={isEmpty(this.groupSlugValue) ? null : this.groupSlugValue}
        />
      </Suspense>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
